<template>
	<div class="news-page-header">
		<!-- 导航栏 -->
		<div class="header-nav">
			<div class="nav-inner">
				<!-- 左侧导航菜单 -->
				<div class="nav-left">
					<span class="nav-item" :class="{ active: currentRoute === 'indexHome' }" @click="navigateTo('indexHome')">{{ $t('header.nav.home') }}</span>
					<span class="nav-item" :class="{ active: currentRoute === 'logisticsQuery' }" @click="navigateTo('logisticsQuery')">{{ $t('header.nav.logisticsQuery') }}</span>
					
					<span class="nav-item" :class="{ active: currentRoute === 'shopIndex'||currentRoute === 'shopCat'||currentRoute === 'shopCar'||currentRoute === 'shopOrder'||currentRoute === 'shopMsg' }" @click="navigateTo('shopIndex')">
						{{ $t('header.nav.shopIndex') }}
						<el-image v-if="currentRoute === 'shopIndex'||currentRoute === 'shopCat'||currentRoute === 'shopCar'||currentRoute === 'shopOrder'||currentRoute === 'shopMsg'" class="nav-indicator" :src="require('@/static/CodeBuddyAssets/31159_1817/9.svg')"></el-image>
					</span>
					
					
					<span class="nav-item" :class="{ active: currentRoute === 'freightEstimate' }" @click="navigateTo('freightEstimate')">{{ $t('header.nav.freightEstimate') }}</span>
					<span class="nav-item" :class="{ active: currentRoute === 'mainBusiness' }" @click="navigateTo('mainBusiness')">{{ $t('header.nav.mainBusiness') }}</span>
					
					
					<span class="nav-item" :class="{ active: currentRoute === 'latestNews'||currentRoute === 'newsDetail' }" @click="navigateTo('latestNews')">
						{{ $t('header.nav.latestNews') }}
						<el-image v-if="currentRoute === 'latestNews'||currentRoute === 'newsDetail'" class="nav-indicator" :src="require('@/static/CodeBuddyAssets/31159_1817/9.svg')"></el-image>
					</span>
					
					<span class="nav-item" @click="link('/userPageLab/faq')">{{ $t('header.nav.faq') }}</span>
					<span class="nav-item" @click="openContactDialog">{{ $t('header.nav.aboutUs') }}</span>
				</div>
				<!-- 右侧用户区 -->
				<div class="nav-right">
					<div class="lang-btn" @click.stop="toggleLangMenu">
						<span>{{ currentLangLabel }}</span>
						<el-image :src="require('@/static/CodeBuddyAssets/31159_1817/11.svg')"></el-image>
						<!-- 语言下拉菜单 -->
						<transition
						name="lang-dropdown"
						@before-enter="onAnimStart"
						@after-enter="onAnimEnd"
						@before-leave="onAnimStart"
						@after-leave="onAnimEnd">
							<div v-show="showLangMenu" class="lang-dropdown">
								<div
									v-for="item in langArr"
									:key="item"
									class="lang-option"
									:class="{ active: $i18n.locale === item }"
									@click.stop="selectLanguage(item)"
								>{{ item === 'zh' ? $t('lanZhTxt') : $t('lanEnTxt') }}</div>
							</div>
						</transition>
					</div>
					<el-image class="exit-icon" :src="require('@/static/CodeBuddyAssets/31159_1817/12.svg')"></el-image>
					<div class="user-info" v-if="!(userInfo)" @click="link('/login')">
						<span>{{ $t('login') }}</span>
					</div>
					<div class="user-info" v-if="userInfo" @click="goToUserCenter">
						<el-image class="avatar-icon" :src="userInfo.portrait"></el-image>
						<span>{{ userInfo.name }}</span>
					</div>
					<el-image class="exit-icon" v-if="userInfo" :src="require('@/static/CodeBuddyAssets/31159_1817/12.svg')"></el-image>
					<span class="exit-text" v-if="userInfo" @click="handleLogout">{{ $t('header.logout') }}</span>
				</div>
			</div>
		</div>
		<!-- 面包屑导航 -->
		<div class="breadcrumb" v-if="currentRoute === 'latestNews'||currentRoute === 'newsDetail'">
			<div class="breadcrumb-inner">
				<span class="crumb-label">{{ $t('header.breadcrumb.label') }}</span>
				<span class="crumb-home" @click="navigateTo('indexHome')">{{ $t('header.breadcrumb.home') }}</span>
				<el-image class="crumb-sep" :src="require('@/static/CodeBuddyAssets/31159_1817/14.svg')"></el-image>
				<template v-if="!ztype">
					<span class="crumb-current">{{ $t('header.breadcrumb.newsPage') }}</span>
				</template>
				<template v-if="ztype">
					<span class="crumb-home" @click="navigateTo('latestNews')">{{ $t('header.breadcrumb.newsPage') }}</span>
					<el-image class="crumb-sep" :src="require('@/static/CodeBuddyAssets/31159_1817/14.svg')"></el-image>
					<span class="crumb-current">{{zname}}</span>
				</template>
			</div>
			<!-- 返回按钮 -->
			<div class="back-btn" v-if="ztype" @click="$router.back()">
				<span>{{ $t('header.breadcrumb.backBtn') }}</span>
				<el-image class="back-icon" :src="require('@/static/CodeBuddyAssets/31159_2065/7.svg')"></el-image>
			</div>
		</div>

		<!-- ====== 联系我们弹窗 ====== -->
		<el-dialog
			:visible.sync="contactDialogVisible"
			width="5.84rem"
			custom-class="contact-dialog"
			:show-close="false"
			:close-on-click-modal="true"
			:append-to-body="true"
			:modal-append-to-body="true">
			
			<!-- 弹窗内容 -->
			<div class="contact-modal">
				<!-- 头部区域（标题 + 关闭按钮） -->
				<div class="modal-header-bg">
					<el-image
						class="modal-close-btn"
						style="opacity: 0;"
						:src="require('@/static/CodeBuddyAssets/32719_3658/1.svg')">
					</el-image>
					<h3 class="modal-title">{{ $t('footer.contact.btnText') }}</h3>
					<el-image 
						class="modal-close-btn"
						:src="require('@/static/CodeBuddyAssets/32719_3658/1.svg')"
						@click="closeContactDialog">
					</el-image>
				</div>

				<!-- 公司信息区域 -->
				<div class="company-info">
					<h4 class="company-name-cn">{{pzMsg.companyName}}</h4>
					<p class="company-name-en">{{pzMsg.companyNameEn}}</p>
					
					<!-- 地址 -->
					<div class="info-row">
						<el-image 
							class="info-icon"
							:src="require('@/static/CodeBuddyAssets/32719_3658/2.svg')">
						</el-image>
						<span class="info-text">{{pzMsg.companyAddress}}</span>
					</div>
					
					<!-- 国内电话 -->
					<div class="info-row info-row--phone">
						<el-image 
							class="info-icon"
							:src="require('@/static/CodeBuddyAssets/32719_3658/3.svg')">
						</el-image>
						<span class="info-text">{{ $t('footer.contact.btnText1') }}：{{pzMsg.chinaPhoneNumber}}</span>
					</div>
					
					<!-- 国际电话 -->
					<div class="info-row info-row--phone">
						<el-image 
							class="info-icon"
							:src="require('@/static/CodeBuddyAssets/32719_3658/4.svg')">
						</el-image>
						<span class="info-text">{{ $t('footer.contact.btnText2') }}：{{pzMsg.foreignPhoneNumber}}</span>
					</div>
				</div>

				<!-- 二维码区域 -->
				<div class="qrcode-section">
					<!-- 微信二维码 -->
					<div class="qrcode-item">
						<el-image 
							class="qrcode-img"
							:src="pzMsg.wechatQrCode"
							:preview-src-list="[pzMsg.wechatQrCode]">
						</el-image>
						<p class="qrcode-label">{{ $t('footer.contact.btnText3') }}</p>
						<p class="qrcode-id">{{pzMsg.wechat}}</p>
					</div>
					
					<!-- WhatsApp二维码 -->
					<div class="qrcode-item">
						<el-image 
							class="qrcode-img"
							:src="pzMsg.whatsappQrCode"
							:preview-src-list="[pzMsg.whatsappQrCode]">
						</el-image>
						<p class="qrcode-label">WhatsAPP</p>
						<p class="qrcode-id">{{pzMsg.whatsapp}}</p>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {
	configbase
} from "/src/api/api.js"
export default {
	name: 'NewsPageHeader',
	props:{
		ztype: {
			type: [Number,String],
			default: 0
		},
		// 弹窗圆角
		zname: {
			type: [Number,String],
			default: ''
		},
	},
	data() {
		return {
			langArr: ['zh', 'en'],
			showLangMenu: false,
			isAnimating: false,
			contactDialogVisible: false,
			pzMsg: '',
		}
	},
	computed: {
		currentRoute() {
			const path = this.$route.path
			return path.replace(/^\//, '')
		},
		currentLangLabel() {
			return this.$i18n.locale === 'zh' ? this.$t('lanZhTxt') : this.$t('lanEnTxt')
		}
	},
	methods: {
		toggleLangMenu() {
			if (this.isAnimating) return
			this.showLangMenu = !this.showLangMenu
		},
		onAnimStart() {
			this.isAnimating = true
		},
		onAnimEnd() {
			this.isAnimating = false
		},
		selectLanguage(lang) {
			this.changeLanguage(lang)
			this.showLangMenu = false
		},
		changeLanguage(lang) {
			this.$i18n.locale = lang
			localStorage.setItem('lang', lang);
		},
		closeLangMenu() {
			this.showLangMenu = false
		},
		navigateTo(route) {
			if (this.currentRoute !== route) {
				this.$router.push('/' + route)
			}
		},
		goToUserCenter() {
			this.$router.push('/userPageLab/userCenter')
		},
		// 退出登录
		async handleLogout() {
			try {
				await this.$confirm(this.$t('confirmDialog.logoutMsg'), this.$t('confirmDialog.logoutTitle'), {
					confirmButtonText: this.$t('confirmDialog.confirmBtn'),
					cancelButtonText: this.$t('confirmDialog.cancelBtn'),
					type: 'warning'
				})
				this.$store.commit('userMsg/tokenC', '')
				this.$store.commit('userMsg/userInfoC', '')
				this.$router.push('/login')
			} catch (err) {
				if (err !== 'cancel') {
					console.error(this.$t('confirmDialog.logoutErr'), err)
				}
			}
		},
		// 配置信息
		async configbase(){
			var res;
			res = await configbase({});
			if(res.code==200){
				this.pzMsg = res.data
			}else{this.Tips(res.msg,'error')}
		},
		openContactDialog() {
			this.contactDialogVisible = true;
		},
		closeContactDialog() {
			this.contactDialogVisible = false;
		}
	},
	mounted() {
		document.addEventListener('click', this.closeLangMenu)
		this.configbase()
	},
	beforeDestroy() {
		document.removeEventListener('click', this.closeLangMenu)
	},
}
</script>

<style lang="scss" scoped>
.news-page-header {
	width: 100%;
	// background: #fff;
}

/* ===== 导航栏 ===== */
.header-nav {
	width: 100%;
	height: 0.84rem;
	background: #fff;
	border-bottom: 0.01rem solid #F0F0F0;
}
.nav-inner {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 100%;
	padding: 0 0.90rem;
	box-sizing: border-box;
}
.nav-left {
	display: flex;
	align-items: center;
}
.nav-item {
	position: relative;
	font-size: 0.16rem;
	font-weight: 500;
	color: #333333;
	cursor: pointer;
	padding: 0 0.24rem;
	line-height: 0.34rem;
	transition: color 0.3s;
	&:hover {
		color: #0096FF;
	}
	&.nav-active {
		color: #0096FF;
	}
	&.active {
		color: #0096FF;
	}
}
.nav-indicator {
	position: absolute;
	bottom: -0.08rem;
	left: 50%;
	transform: translateX(-50%);
	width: 0.24rem;
	height: 0.03rem;
}

/* ===== 右侧用户区 ===== */
.nav-right {
	display: flex;
	align-items: center;
	gap: 0.16rem;
}
.lang-btn {
	position: relative;
	display: flex;
	align-items: center;
	font-size: 0.16rem;
	font-weight: 500;
	color: #333333;
	cursor: pointer;
	.el-image {
		margin-left: 0.04rem;
		width: 0.16rem;
		height: 0.16rem;
	}
	/* 语言下拉菜单 */
	.lang-dropdown {
		position: absolute;
		top: 100%;
		left: 0;
		margin-top: 0.08rem;
		background: #fff;
		border-radius: 0.06rem;
		box-shadow: 0 0.04rem 0.12rem rgba(0, 0, 0, 0.15);
		overflow: hidden;
		z-index: 200;
		min-width: 1.20rem;
	}

	/* ========== 语言下拉菜单动效：淡入淡出 + 向下滑出 ========== */
	.lang-dropdown-enter-active,
	.lang-dropdown-leave-active {
		transition: opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1),
		            transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
		transform-origin: top center;
	}
	.lang-dropdown-enter,
	.lang-dropdown-leave-to {
		opacity: 0;
		transform: scaleY(0.92) translateY(-0.04rem);
	}
	/* 减少动态偏好：禁用动画 */
	@media (prefers-reduced-motion: reduce) {
		.lang-dropdown-enter-active,
		.lang-dropdown-leave-active {
			transition: none;
		}
		.lang-dropdown-enter,
		.lang-dropdown-leave-to {
			opacity: 1;
			transform: none;
		}
	}
	.lang-option {
		padding: 0.10rem 0.16rem;
		font-size: 0.14rem;
		color: #333;
		cursor: pointer;
		transition: background-color 0.2s, color 0.2s;
		&:hover {
			background: #f5f7fa;
			color: #0096FF;
		}
		&.active {
			color: #0096FF;
			font-weight: 600;
		}
	}
}
.user-info {
	display: flex;
	align-items: center;
	font-size: 0.16rem;
	font-weight: 500;
	color: #333333;
	.avatar-icon {
		width: 0.38rem;
		height: 0.38rem;
		border-radius: 50%;
		border: 1px solid #000;
		margin-right: 0.12rem;
	}
}
.exit-icon {
	width: 0.14rem;
	height: 0.14rem;
}
.exit-text {
	font-size: 0.16rem;
	font-weight: 500;
	color: #333333;
	cursor: pointer;
	&:hover {
		color: #0096FF;
	}
}

/* ===== 面包屑 ===== */
.breadcrumb {
	padding: 0.30rem 0 0;
	background: transparent;
}
.breadcrumb-inner {
	padding-left: 3.14rem;
	display: flex;
	align-items: center;
}
.crumb-label {
	font-size: 0.16rem;
	font-weight: 400;
	color: #333333;
}
.crumb-home {
	font-size: 0.16rem;
	font-weight: 400;
	color: #666666;
	cursor: pointer;
	transition: color 0.3s;
	&:hover {
		color: #0096FF;
	}
}
.crumb-sep {
	width: 0.12rem;
	height: 0.12rem;
	margin: 0 0.06rem;
}
.crumb-current {
	font-size: 0.16rem;
	font-weight: 400;
	color: #0096FF;
}
/* ===== 返回按钮 ===== */
.back-btn {
	position: absolute;
	right: 2.87rem;
	top: 0.30rem;
	display: flex;
	align-items: center;
	cursor: pointer;
	transition: opacity 0.3s;
	&:hover { opacity: 0.75; }
	span {
		font-size: 0.16rem;
		font-weight: 400;
		color: #0096FF;
	}
	.back-icon {
		width: 0.14rem;
		height: 0.12rem;
		margin-left: 0.08rem;
	}
}

/* ============================================================
   联系我们弹窗样式 (基于 Figma 设计 - 无定位属性)
   ============================================================ */
.contact-modal {
	background: white;
	border-radius: 10px;
	box-sizing: border-box;
	padding: 3px;
}

/* 头部区域（渐变背景 + 标题 + 关闭按钮） */
.modal-header-bg {
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 66px;
	background: linear-gradient(180deg, #E4F4FF 0%, white 100%);
	border-top-left-radius: 10px;
	border-top-right-radius: 10px;
	padding: 0 16px;
}

/* 标题 */
.modal-title {
	font-size: 22px;
	font-family: 'PingFang SC', sans-serif;
	font-weight: 500;
	color: #2F3541;
	margin: 0;
	white-space: nowrap;
}

/* 关闭按钮 */
.modal-close-btn {
	width: 20px;
	height: 20px;
	cursor: pointer;
	flex-shrink: 0;
	transition: opacity 0.3s;
	&:hover {
		opacity: 0.7;
	}
}

/* 公司信息区域 */
.company-info {
	padding: 20px 60px;
}

.company-name-cn {
	font-size: 24px;
	font-family: 'PingFang SC', sans-serif;
	font-weight: 500;
	color: #333333;
	white-space: nowrap;
	text-align: center;
	margin-bottom: 10px;
}

.company-name-en {
	font-size: 14px;
	font-family: 'PingFang SC', sans-serif;
	font-weight: 400;
	color: #CBCBCB;
	white-space: nowrap;
	text-align: center;
	margin-bottom: 26px;
}

/* 信息行（地址、电话） */
.info-row {
	display: flex;
	align-items: center;
	height: 22px;
	margin-bottom: 24px;
	&:last-child{
		margin-bottom: 10px;
	}
	
	.info-icon {
		width: 18px;
		height: 18px;
		flex-shrink: 0;
	}
	
	.info-text {
		margin-left: 8px;
		font-size: 16px;
		font-family: 'PingFang SC', sans-serif;
		font-weight: 400;
		color: #7C8388;
		white-space: nowrap;
	}
}

.info-row--phone {
	width: auto;
}

/* 二维码区域 */
.qrcode-section {
	display: flex;
	justify-content: center;
	align-items: flex-start;
	padding: 30px 0 20px;
	padding-top: 10px;
}

.qrcode-item {
	width: 158px;
	text-align: center;
	margin: 0 21px;
	
	.qrcode-img {
		width: 158px;
		height: 158px;
		cursor: pointer;
		display: block;
		border: 1px solid #eee;
		margin-bottom: 10px;
	}
	
	.qrcode-label {
		font-size: 16px;
		font-family: 'PingFang SC', sans-serif;
		font-weight: 400;
		color: #333333;
		margin: 8px 0 4px;
	}
	
	.qrcode-id {
		font-size: 18px;
		font-family: 'PingFang SC', sans-serif;
		font-weight: 400;
		color: #0096FF;
		margin: 0;
	}
}
</style>

<!-- 全局样式：覆盖 el-dialog 默认样式 -->
<style lang="scss">
.contact-dialog {
	border-radius: 10px !important;
	overflow: visible;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
	
	.el-dialog__header {
		display: none;
		padding: 0;
		margin: 0;
	}
	
	.el-dialog__body {
		padding: 6px;
	}
	
	.el-dialog__footer {
		display: none;
		padding: 0;
		margin: 0;
	}
}
</style>
